<template>
    <v-row class="ma-0 px-4" justify="space-between">
        <v-sheet color="transparent" class="mt-4">
             <span class="textappBAR"> SMARTLINK RAOS </span>
        </v-sheet>
        <v-btn-toggle v-model="toggle_one" mandatory class="mt-2" color="btnSelectBar" base-color="background">
            <v-btn> {{ t('title.home') }} </v-btn>
            <v-btn> {{ t('title.status') }} </v-btn>
            <v-btn> {{ t('title.location') }} </v-btn>
            <v-btn> KPI </v-btn>
            <v-btn> {{ t('title.admin') }} </v-btn>
            <v-btn> {{ t('title.report') }} </v-btn>
        </v-btn-toggle>
        
        <LangAndMenu/>
    </v-row>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/********************************
 ************ ROUTER ************
 *******************************/
import router from '@/router';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { VISIBLE_PAGES } from '@/constants/labels';

/********************************
 ********** COMPONENTES *********
 *******************************/
import LangAndMenu from '@/components/PrincipalComponents/LangAndMenu.vue';

const toggle_one = ref(0)

const VISUAL_OBJ:any = {
    0 : VISIBLE_PAGES.raosinit,
    1 : VISIBLE_PAGES.raosstatus,
    2 : VISIBLE_PAGES.raosmap,
    3 : VISIBLE_PAGES.raoskpi,
    4 : VISIBLE_PAGES.raosmng,
    5 : VISIBLE_PAGES.raosreport,
}

watch(toggle_one,(val:number) => {
    changeView(VISUAL_OBJ[val])
})


const changeView = (viewPage: string) => {
  router.push(`/smartlinkRAOS/${viewPage}`)
}
</script>

<style scoped>

</style>